import { render, staticRenderFns } from "./DuplicateFinder.vue?vue&type=template&id=7b487131"
import script from "./DuplicateFinder.vue?vue&type=script&lang=js"
export * from "./DuplicateFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports